import {
  Box,
  Container,
  Paper,
  TextField,
  IconButton,
  Button,
  InputAdornment,
} from "@mui/material";
import { Search, Download } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import variables from "../../../assets/styles/variables.module.scss";
import { useDispatch } from "react-redux";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { ShowError } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import MetaInstance from "../../../Services/AxiosInstance/MetaInstance";
import { AUDIT_LOG } from "../../../Services/Endpoint";
import * as XLSX from 'xlsx';

const AuditLogs = () => {
  const dispatch = useDispatch()
  const [searchInput, setSearchInput] = useState(""); // Input field value
  const [searchQuery, setSearchQuery] = useState(""); // Search query applied
  const [pagination, setPagination] = useState({ page: 1, pageSize: 10 });
  const [auditLog, setAuditLog] = useState([])
  const [totalPage, setTotalPage] = useState(0)


  useEffect(() => {
    getAuditLog()
  }, [pagination])

    const getAuditLog = async () => {
        try {
            dispatch(StartLoading());
            const data = await MetaInstance.get(
                `${AUDIT_LOG}?email=${searchQuery}&page=${pagination.page}&limit=${pagination.pageSize}`
            ).then(res => res?.data?.detail);

            setAuditLog(data.response || []);
            
            setTotalPage(pagination.pageSize * pagination.page + 1)

        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.detail?.response));
        } finally {
            dispatch(StopLoading());
        }
    };




  const handleSearch = () => {
    setSearchQuery(searchInput); // Apply search when button is clicked
  };


  const handlePaginationMetaChange = (paginationMeta: any) => {
    const { page, pageSize, rowCount } = paginationMeta;
    setPagination({ page: page + 1, pageSize: pageSize })
  };


  const downloadExcel = () => {
    const data: any = []
    // Define the specific order of keys
    const keyOrder: any = ['userId', 'timestamp', 'IPaddress', 'url', 'action', 'httpStatusCode', 'statusDetails'];

    // Reorder the object based on the keyOrder array
    auditLog.map((logObj: any) => {
      const reorderedObj = keyOrder.reduce((acc: any, key: any) => {
        if (logObj.hasOwnProperty(key)) {
          acc[key] = logObj[key];
        }
        return acc;
      }, {});
      data.push(reorderedObj)
    })

    const Heading = [['Username', 'Created Date', 'IPAddress', 'Action',  'Method', 'StatusCode', 'Details']];

        const wb = XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
        XLSX.utils.sheet_add_aoa(ws, Heading);

        //Starting in the second row to avoid overriding and skipping headers
        XLSX.utils.sheet_add_json(ws, data, { origin: 'A2', skipHeader: true });

        XLSX.utils.book_append_sheet(wb, ws, 'Audit Log');

        XLSX.writeFile(wb, 'Audit_Log_Report.xlsx');
  };


  const columns: GridColDef[] = [
    { field: "userId", headerName: "Username", width: 150 },
    { field: "timestamp", headerName: "Created Date", width: 180 },
    { field: "IPaddress", headerName: "IP Address", width: 180 },
    { field: "action", headerName: "Method", width: 120 },
    { field: "url", headerName: "Actions", width: 250 },
    { field: "httpStatusCode", headerName: "Status Code", width: 130 },
    { field: "statusDetails", headerName: "Details", width: 200 },
  ];

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Breadcrumb data={[{ name: "Audit Logs", path: "" }]} />

        <Box sx={{ display: "flex", gap: 2 }}>
          {/* Download Button */}
          <IconButton
            color="primary"
            onClick={downloadExcel}
            sx={{
              border: 1,
              borderColor: variables.borderColor,
              borderRadius: "4px",
              padding: "8px",
            }}
            title="Report File Download"
          >
            <Download />
          </IconButton>

          {/* Search Input Field with Search Icon Inside */}
          <TextField
            size="small"
            label="Search by Username"
            variant="outlined"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSearch();
            }}
            sx={{ width: "250px" }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleSearch} edge="end">
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>

      {/* Data Grid Table */}
      <Paper sx={{ height: 400, width: "100%" }} elevation={0}>
        <DataGrid
            rows={auditLog}
            columns={columns}
            rowCount={totalPage} 
            paginationMode="server"
            pageSizeOptions={[10]} 
            paginationModel={{ page: pagination.page - 1, pageSize: pagination.pageSize }} 
            onPaginationModelChange={(model) => setPagination({ page: model.page + 1, pageSize: model.pageSize })}
            getRowId={(row) => row.timestamp}
            autoHeight
            sx={{
                border: 1,
                borderColor: variables.borderColor,
                "& .MuiDataGrid-cell:focus": { outline: "none" },
                "& .MuiDataGrid-cell:focus-within": { outline: "none" },
            }}
        />
      </Paper>
    </Container>
  );
};

export default AuditLogs;
